module.exports = __webpack_public_path__ + "static/RufusA-3c1e6cf87682ab54e44737e6ca9801c3.gif";